<span
  [ngClass]="
    featured
      ? 'inline-flex items-center rounded-lg border border-brand-400/40 bg-brand-500/20 px-2.5 py-1 text-xs font-semibold text-brand-200'
      : 'inline-flex items-center rounded-lg border border-brand-500/15 bg-brand-500/10 px-2.5 py-1 text-xs font-medium text-brand-300'
  "
>
  {{ label }}
</span>
